import { createApi } from '../config/create-api';

import { COIN_GECKO_ENDPOINTS, GetPriceChartRequest, GetPriceChartResponse } from './coingecko.model';

const coinGeckoApi = createApi(build => ({
    get: {
        priceChart: build<GetPriceChartResponse, GetPriceChartRequest>({
            cachePrefix: 'coin-gecko-price-chart',
            baseUrl: 'coingecko-pro',
            query: ({ slug, from, to, vsCurrency, coingeckoApiKey }) => ({
                uri: COIN_GECKO_ENDPOINTS.GET.PRICE_CHART({ slug }),
                params: {
                    vs_currency: vsCurrency,
                    from,
                    to,
                    x_cg_pro_api_key: coingeckoApiKey,
                },
                options: {
                    credentials: 'omit',
                },
            }),
        }),
    },
}));

export { coinGeckoApi };
